module.exports = __webpack_public_path__ + "img/children-potatoes-1.c776e223.jpg";